import React from 'react';
import styles from './StatusBadge.module.css';

interface StatusBadgeProps {
  status: 'Pending' | 'Picking' | 'Packed';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const statusClass = {
    Pending: styles.pending,
    Picking: styles.picking,
    Packed: styles.packed,
  }[status];

  return (
    <span className={`${styles.badge} ${statusClass}`}>
      {status}
    </span>
  );
};
